<div class="quantity-input" *ngIf="mode=='list'" [ngClass]="{'color-red': errorTypes.includes('qty_error'), 'color-disabled': errorTypes.includes('invalid_error')}">
    <div (click)="decrease()" class="minus flex-center" [ngClass]="{'disabled': errorTypes.includes('invalid_error')}">
      <svg-icon *ngIf="!(errorTypes.includes('invalid_error'))" [iconName]="'new/minus.svg'"></svg-icon>
      <svg-icon *ngIf="errorTypes.includes('invalid_error')" [iconName]="'new/minus-grey.svg'"></svg-icon>
    </div>
    <nz-input-group class="text-center">
      <input
        nz-input
        type="number"
        [disabled]="errorTypes.includes('invalid_error')"
        [(ngModel)]="quantity"
        [ngStyle]="errorTypes.includes('invalid_error') ? { background: '#F0F0F0', color: '#595E62' } : (errorTypes.includes('qty_error') ? {color: '#ED0007' }:(errorTypes.includes('qty_warning') ? {color: '#18837E' }:{}))"
        (blur)="onBlur()"
        (change)="onBlur()"
        (ngModelChange)="onInputChange($event)"
        [attr.min]="moq"
        [attr.step]="moq"
        title=""
        autocomplete="off"
        placeholder=""
      />
    </nz-input-group>
    <div (click)="increase()" class="plus flex-center" [ngClass]="{'disabled': errorTypes.includes('invalid_error')}">
      <svg-icon *ngIf="!(errorTypes.includes('invalid_error'))" [iconName]="'new/plus.svg'"></svg-icon>
      <svg-icon *ngIf="errorTypes.includes('invalid_error')" [iconName]="'new/plus-grey.svg'"></svg-icon>
    </div>
  </div>
  <div class="quantity-table-input" *ngIf="mode=='table'|| mode=='wishList'" [ngClass]="{'color-red': errorTypes.includes('qty_error'), 'color-disabled-table': errorTypes.includes('invalid_error')}">
    <div (click)="decrease()" class="minus flex-center" [ngClass]="{'disabled': errorTypes.includes('invalid_error')}">
      <svg-icon *ngIf="!(errorTypes.includes('invalid_error'))" [iconName]="'new/minus.svg'"></svg-icon>
      <svg-icon *ngIf="errorTypes.includes('invalid_error')" [iconName]="'new/minus-grey.svg'"></svg-icon>
    </div>
    <nz-input-group class="text-center" *ngIf="mode=='table'" nz-popover [nzPopoverPlacement]="'top'"
    [nzPopoverContent]="qtyTemplate">
      <input
        nz-input
        type="number"
        [disabled]="errorTypes.includes('invalid_error')"
        [(ngModel)]="quantity"
        [ngStyle]="errorTypes.includes('invalid_error') ? { background: '#FFEBEB', color: '#595E62' } : (errorTypes.includes('qty_error') ? {color: '#ED0007' }:(errorTypes.includes('qty_warning') ? {color: '#18837E' }:{}))"
        (blur)="onBlur()"
        (change)="onBlur()"
        (ngModelChange)="onInputChange($event)"
        [attr.min]="moq"
        [attr.step]="moq"
        placeholder=""
        title=""
        autocomplete="off"
      />
    </nz-input-group>
    <nz-input-group class="text-center wishList" *ngIf="mode=='wishList'">
      <input
        nz-input
        type="number"
        [(ngModel)]="quantity"
        (blur)="onBlur()"
        (ngModelChange)="onInputChange($event)"
        [attr.min]="moq"
        [attr.step]="moq"
        placeholder=""
        title=""
        autocomplete="off"
      />
    </nz-input-group>
    <div (click)="increase()" class="plus flex-center" [ngClass]="{'disabled': errorTypes.includes('invalid_error')}">
      <svg-icon  [iconName]="'new/plus.svg'"></svg-icon>
    </div>
    <ng-template #qtyTemplate>
      <div>
        <div class="flex">
          <span class="info-title font14-w500"> {{'INPUT_NO' | translate}}</span>
          <span class="font14-w500">{{inputQuantity || '--'}}</span>
        </div>
      </div>
    </ng-template>
  </div>
  
